import React from "react";
import "./Dashboard.css";
import { NavLink } from "react-router-dom";
import { Link } from "react-router-dom";
import { motion } from "framer-motion";

import logo from "../assets/LogoS.png";

const NavbarDashboard = () => {
  return (
    <>
      <Link to="/dashboard" className="logo logo-dash">
        <img src={logo} alt="logoDashboard" width={160} height={45} />
      </Link>
      <ul className="dashboard-links">
        <motion.li className="nav-item-dashboard" whileHover={{ x: -10 }}>
          <NavLink
            to="/dashboard/addcourse"
            className="nav-links nav-links-custom"
          >
            Add Course
          </NavLink>
        </motion.li>

        <motion.li className="nav-item-dashboard" whileHover={{ x: -10 }}>
          <NavLink
            to="/dashboard/allcourses"
            className="nav-links nav-links-custom"
          >
            All Courses
          </NavLink>
        </motion.li>
        <motion.li className="nav-item-dashboard" whileHover={{ x: -10 }}>
          <NavLink
            to="/dashboard/addinstructor"
            className="nav-links nav-links-custom"
          >
            Add Instructor
          </NavLink>
        </motion.li>
        <motion.li className="nav-item-dashboard" whileHover={{ x: -10 }}>
          <NavLink
            to="/dashboard/allinstructors"
            className="nav-links nav-links-custom"
          >
            All Instructors
          </NavLink>
        </motion.li>

        <motion.li className="nav-item-dashboard" whileHover={{ x: -10 }}>
          <NavLink
            to="/dashboard/addvideo"
            className="nav-links nav-links-custom"
          >
            Add Video
          </NavLink>
        </motion.li>

        <motion.li className="nav-item-dashboard" whileHover={{ x: -10 }}>
          <NavLink
            to="/dashboard/add-questions"
            className="nav-links nav-links-custom"
          >
            Add Questions
          </NavLink>
        </motion.li>
        <motion.li className="nav-item-dashboard" whileHover={{ x: -10 }}>
          <NavLink
            to="/dashboard/all-questions"
            className="nav-links nav-links-custom"
          >
            All Questions
          </NavLink>
        </motion.li>
        <motion.li className="nav-item-dashboard" whileHover={{ x: -10 }}>
          <NavLink
            to="/dashboard/add-story"
            className="nav-links nav-links-custom"
          >
            Add story
          </NavLink>
        </motion.li>
        <motion.li className="nav-item-dashboard" whileHover={{ x: -10 }}>
          <NavLink
            to="/dashboard/all-stories"
            className="nav-links nav-links-custom"
          >
            All stories
          </NavLink>
        </motion.li>

        <motion.li className="nav-item-dashboard" whileHover={{ x: -10 }}>
          <NavLink
            to="/dashboard/all-users"
            className="nav-links nav-links-custom"
          >
            All Users
          </NavLink>
        </motion.li>

        <motion.li className="nav-item-dashboard" whileHover={{ x: -10 }}>
          <NavLink
            to="/dashboard/pricing"
            className="nav-links nav-links-custom"
          >
            Pricing
          </NavLink>
        </motion.li>
      </ul>
    </>
  );
};

export default NavbarDashboard;
